import { ButtonHTMLAttributes, DetailedHTMLProps } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/sharp-regular-svg-icons";
import styles from "./pill-radio-button.module.scss";

interface PillRadioButtonProps extends Omit<
  DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>,
  "type" | "children"
> {
  children: string;
  selected?: boolean;
  iconType?: "positive" | "negative";
}

export function PillRadioButton({
  children,
  selected = false,
  iconType = "positive",
  className,
  ...props
}: PillRadioButtonProps) {
  const icon = iconType === "positive" ? faCheck : faXmark;

  return (
    <button
      {...props}
      type="button"
      className={`
        ${styles.button}
        rounded-full
        border text-left
        ${selected ? styles.selected : styles.unselected}
        ${className ?? ""}
      `}
      name={children}
    >
      <div
        className={`
          ${styles.iconContainer}
          rounded-full flex items-center justify-center flex-shrink-0
          ${selected ? styles.selectedIcon : styles.unselectedIcon}
        `}
      >
        <FontAwesomeIcon icon={icon} className={styles.icon} />
      </div>
      <div className={styles.content}>
        <div className={styles.label}>{children}</div>
      </div>
    </button>
  );
}
